// @ts-expect-error - virtual module only in prod
import { registerSW } from "virtual:pwa-register";

export const registerPWA = () => {
  // Register SW only if supported and NOT running Cypress tests
  if ("serviceWorker" in navigator && !(window as any).Cypress) {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        console.log("New version available. Refreshing...");
        updateSW(true); // Force reload
      },
      onOfflineReady() {
        console.log("App ready for offline use");
      },
    });
  }
};
